import { TradeType } from '../enums/trade-type.enum';

import { enumSchema } from './../../utils/enum.utils';

export interface PhaseTemplate {
  id: string;
  name: string;
  tradeType: TradeType;
  order: number;
  lastModifiedById: string;
  lastModified: Date;
}

export const phaseTemplateChatbotFields = {
  id: { type: 'string', description: 'Must be specified for update or delete.' },
  name: {
    type: 'string',
    description: 'Must be specified for new entries. Otherwise should be only set if the intend it to change it.',
  },
  tradeType: enumSchema(
    'TradeType',
    TradeType,
    'Must be specified for new entries. Otherwise should be only set if the intend it to change it.'
  ),
  order: { type: 'number', description: 'Optional. Describes the order in the list.' },
};
